import React, { createContext, useContext } from "react";
import { Step } from "intro.js-react";

import appConfig from "../../app.config";

import { WebId } from "../slices/local/orchestrator";
import { useAppSelector } from "../state/hooks";
import { selectCubes, selectStations, selectJingles } from "../state/selectors";

export interface TourStep extends Step {
  /**
   * Location to switch to before executing this step.
   */
  location?: string;
}

interface TourContextValues {
  steps: TourStep[];
}

const TourContext = createContext<TourContextValues>({
  steps: []
});

const TourProvider = ({ children }: { children: React.ReactNode }): any => {
  const cubes = useAppSelector(selectCubes);
  const stations = useAppSelector(selectStations);
  const jingles = useAppSelector(selectJingles);

  const tourData = {
    steps: appConfig.tourSteps({
      WebId,
      cubes,
      stations,
      jingles
    })
  };

  return (
    <TourContext.Provider value={tourData}>
      {children}
    </TourContext.Provider>
  );
};

const useTour = (): TourContextValues => useContext(TourContext);

export {
  TourProvider,
  useTour
};
